import { ArrowUpRight, Mail } from "lucide-react";
import { LogoMark } from "./Logo";
import { STORE_URL, STORE_EMAIL, INSTAGRAM_URL } from "../../data/catalog";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-[#050609] pt-20" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1400px] gap-10 px-5 md:grid-cols-3 lg:px-10">
      <div>
        <LogoMark className="h-20 w-20" />
        <p className="mt-5 max-w-xs text-sm text-slate-300">Your trusted source for premium TCG cards. Tracked UK shipping & worldwide delivery.</p>
      </div>
      <div className="flex flex-col gap-3">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Shop</span>
        <a href={STORE_URL} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-ebay-link">The Vault <ArrowUpRight className="h-4 w-4" /></a>
        <a href="https://www.ebay.co.uk/str/instanttcgz?_tab=feedback" target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-feedback-link">Seller feedback <ArrowUpRight className="h-4 w-4" /></a>
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-instagram-link">Instagram <ArrowUpRight className="h-4 w-4" /></a>
      </div>
      <div className="flex flex-col gap-3">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Orders & enquiries</span>
        <a href={`mailto:${STORE_EMAIL}`} className="footer-link break-all" data-testid="footer-email-link"><Mail className="h-4 w-4 shrink-0" /> {STORE_EMAIL}</a>
      </div>
    </div>
    <div className="mt-20 select-none px-3 text-center font-display text-[15.5vw] font-black uppercase leading-[0.8] tracking-[-0.04em] text-outline-soft" aria-hidden="true">
      InstantTCGZ
    </div>
    <div className="mx-auto flex max-w-[1400px] flex-col justify-between gap-2 border-t border-white/10 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400 sm:flex-row lg:px-10">
      <span>© 2026 InstantTCGZ</span>
<span>All card games are trademarks of their respective owners</span>
    </div>
  </footer>
);
